import TFGRequestsTable from './TFGRequestsTable';

export default TFGRequestsTable;
